import { createBrowserRouter, Navigate } from 'react-router-dom';
import PortalShell  from './components/PortalShell';
import Evidence     from './pages/Evidence';
import Merkle       from './pages/Merkle';
import Proofs       from './pages/Proofs';
import RGPD         from './pages/RGPD';
import ZkpVerifier  from './pages/ZkpVerifier';

export type TierSlug = 'pita' | 'cag' | 'fmd';
export type PackSlug = 'ccp' | 'sfp' | 'pag' | 'ccp-sfp' | 'ccp-pag' | 'sfp-pag' | 'all';

export const VALID_TIERS: TierSlug[] = ['pita', 'cag', 'fmd'];
export const VALID_PACKS: PackSlug[] = ['ccp', 'sfp', 'pag', 'ccp-sfp', 'ccp-pag', 'sfp-pag', 'all'];

export const router = createBrowserRouter([
  {
    path: '/',
    Component: PortalShell,
    children: [
      { index: true, element: <Navigate to="/evidence" replace /> },
      { path: 'evidence', Component: Evidence },
      { path: 'merkle',   Component: Merkle },
      { path: 'proofs',   Component: Proofs },
      { path: 'rgpd',     Component: RGPD },
      { path: 'zkp',      Component: ZkpVerifier },
      { path: '*', element: <Navigate to="/evidence" replace /> },
    ],
  },
]);
